/*
  © 2024 Jhango
  https://www.jhango.com
*/

class Navbar extends HTMLElement {
  constructor () {
    super()

    this.handleHeaderReveal()
  }

  handleHeaderReveal () {
    // Disabled: Keep header section and navigation bar 100% static & fixed when scrolling
    const headerGroup = document.querySelector('#header-group')
    if (headerGroup) {
      headerGroup.classList.remove('hide')
    }
  }

}
customElements.define('navbar-wrapper', Navbar)

class HeroCarousel extends HTMLElement {
  constructor () {
    super()
  }

  animateOnScroll () {
    // Disabled: Keep hero section image 100% static and clean on scroll
  }
}
customElements.define('hero-carousel', HeroCarousel)

class StickyMedia extends HTMLElement {
  constructor () {
    super()

    this.animateOnScroll()
  }

  animateOnScroll () {
    let ticking = false
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const windowHeight = window.innerHeight
          if (windowHeight > 0) {
            const top = this.getBoundingClientRect().top
            const bottom = this.getBoundingClientRect().bottom
            const visibilityTop = Math.round(top / windowHeight * 100)
            const visibilityBottom = Math.round(bottom / windowHeight * 100)

            if (visibilityTop > 0 && visibilityTop < 100) {
              this.querySelectorAll('.media-wrapper').forEach(elem => {
                const overlayOpacity = Number(elem.dataset.overlayOpacity)
                const final = Math.round((100 - overlayOpacity) * visibilityTop / 100 + overlayOpacity)
                elem.style.setProperty('--overlay-opacity', final + '%')
              })
            } else if (visibilityBottom > 0 && visibilityBottom < 100) {
              this.querySelectorAll('.media-wrapper').forEach(elem => {
                const overlayOpacity = Number(elem.dataset.overlayOpacity)
                const final = Math.round((100 - overlayOpacity) * (1 - visibilityBottom / 100) + overlayOpacity)
                elem.style.setProperty('--overlay-opacity', final + '%')
              })
            }
          }
          ticking = false
        })
        ticking = true
      }
    }, { passive: true })
  }
}
customElements.define('sticky-media', StickyMedia)

class Marquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    const list = this.querySelector('.marquee-list')
    list.querySelectorAll('.marquee-item[aria-hidden="true"]').forEach(elem => elem.remove())

    const marqueeWidth = list.scrollWidth
    const marqueeLength = list.querySelectorAll('li').length

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)
    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('.marquee-item').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #marquee-${this.dataset.marqueeId} .marquee-list {
          animation-name: marquee_animation_${this.dataset.marqueeId};
          animation-duration: ${this.dataset.marqueeDuration}s;
        }
        @keyframes marquee_animation_${this.dataset.marqueeId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes marquee_animation_${this.dataset.marqueeId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('marquee-container', Marquee)

class NewsletterPopup extends HTMLElement {
  constructor () {
    super()

    if (window.Shopify.designMode) return

    if (window.location.href.includes('newsletter-popup')) {
      window.bootstrap.Modal.getOrCreateInstance(this).show()
      return
    }

    if (document.cookie.indexOf('ks-newsletter-popup') > -1) {
      return
    };

    (async () => {
      await new Promise(resolve => setTimeout(resolve, Number(this.dataset.configDelay) * 1000))
      window.theme.createCookie('ks-newsletter-popup', true, Number(this.dataset.configDaysToWait))
      window.bootstrap.Modal.getOrCreateInstance(this).show()
    })()
  }
}
customElements.define('newsletter-popup', NewsletterPopup)

class ParallaxMedia extends HTMLElement {
  constructor () {
    super()

    this.animateOnScroll()

    const script = document.querySelector('script[src*="vendor-simple-parallax"]')
    script.onload = () => {
      this.init()
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    // eslint-disable-next-line no-new, new-cap
    new window.simpleParallax(this.querySelectorAll('.parallax-media-media'), {
      orientation: this.dataset.parallaxOrientation,
      scale: Number(this.dataset.parallaxScale)
    })
  }

  animateOnScroll () {
    window.addEventListener('scroll', () => {
      const windowHeight = window.innerHeight
      const sectionHeight = this.clientHeight

      const top = Math.round(this.getBoundingClientRect().top)
      const bottom = Math.round(this.getBoundingClientRect().bottom)
      const visibilityTop = Math.round((windowHeight - top) / sectionHeight * 100)
      const visibilityBottom = Math.round(bottom / sectionHeight * 100)

      if (visibilityTop > 0 && visibilityTop < 100) {
        this.querySelectorAll('.media-wrapper').forEach(elem => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity)
          const final = Math.round((100 - overlayOpacity) * (1 - visibilityTop / 100) + overlayOpacity)
          elem.style.setProperty('--overlay-opacity', final + '%')
        })
      } else if (visibilityBottom > 0 && visibilityBottom < 100) {
        this.querySelectorAll('.media-wrapper').forEach(elem => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity)
          const final = Math.round((100 - overlayOpacity) * (1 - visibilityBottom / 100) + overlayOpacity)
          elem.style.setProperty('--overlay-opacity', final + '%')
        })
      }
    })
  }
}
customElements.define('parallax-media', ParallaxMedia)

class MyImageCompare extends HTMLElement {
  constructor () {
    super()

    const script = document.querySelector('script[src*="vendor-image-compare"]')
    script.onload = () => {
      this.init()
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    this.querySelectorAll('[data-image-compare]').forEach(elem => {
      new window.ImageCompare(elem, {
        controlColor: this.dataset.icvControlsColor,
        controlShadow: true,
        addCircle: this.dataset.icvControlsCircle === 'true',
        addCircleBlur: true,
        showLabels: this.dataset.icvShowLabels === 'true',
        labelOptions: {
          before: this.dataset.icvLabelBefore,
          after: this.dataset.icvLabelAfter,
          onHover: false
        },
        smoothing: this.dataset.icvSmoothing === 'true',
        smoothingAmount: 100,
        hoverStart: this.dataset.icvHoverStart === 'true',
        verticalMode: this.dataset.icvVerticalMode === 'true',
        startingPoint: Number(this.dataset.icvStartingPoint),
        fluidMode: false
      }).mount()
    })
  }
}
customElements.define('image-compare', MyImageCompare)

class SimpleCollections extends HTMLElement {
  constructor () {
    super()

    if (window.matchMedia('(max-width: 799px)').matches) {
      setTimeout(() => {
        const left = this.querySelector('.simple-collections-item.active')?.getBoundingClientRect().left || 0
        this.scrollBy({ left, behavior: 'smooth' })
      }, 1000)
    }
  }
}
customElements.define('simple-collections', SimpleCollections)

class LookBook extends HTMLElement {
  constructor () {
    super()

    this.points = this.querySelectorAll('.lookbook-point-list button')
    this.mySwiper = this.querySelector('.swiper').swiper

    this.points.forEach(elem => {
      elem.addEventListener('click', () => this.onPointerClick(elem))
    })

    this.mySwiper.on('slideChange', () => this.onSlideChange())
  }

  onPointerClick (btn) {
    this.mySwiper.slideTo(Number(btn.dataset.index))
    this.scrollIntoView()
  }

  onSlideChange () {
    const selectedPoint = this.points[this.mySwiper.activeIndex]

    this.points.forEach(elem => {
      elem.classList.remove('active')
      if (elem.dataset.index !== selectedPoint.dataset.index) {
        window.bootstrap.Tooltip.getOrCreateInstance(elem).hide()
      }
    })

    selectedPoint.classList.add('active')

    if (!selectedPoint.getAttribute('aria-describedby')) {
      window.bootstrap.Tooltip.getOrCreateInstance(selectedPoint).show()
    }
  }
}
customElements.define('look-book', LookBook)

class ShoppableVideos extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('a[data-quick-view]').forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        this.openQuickView(link)
      })
    })

    this.querySelector('.swiper').swiper.on('slideChange', () => {
      this.querySelectorAll('video').forEach(video => {
        if (video.closest('.card').dataset.playing === 'true') {
          video.closest('.card').setAttribute('data-playing', 'false')
          video.pause()
        }
      })
    })
  }

  onVideoPlay (video) {
    this.querySelectorAll('video').forEach(elem => {
      if (elem.dataset.index !== video.dataset.index) {
        elem.closest('.card').setAttribute('data-playing', 'false')
        elem.pause()
      }
    })

    const card = video.closest('.card')

    if (card.dataset.playing === 'true') {
      video.closest('.card').setAttribute('data-playing', 'false')
      video.pause()
    } else {
      video.closest('.card').setAttribute('data-playing', 'true')
      video.muted = false
      video.play()
    }
  }

  async openQuickView (link) {
    if (!link || !link.dataset.productUrl) return

    link.disabled = true
    link.setAttribute('aria-busy', 'true')
    link.querySelector('.icon-wrapper')?.setAttribute('hidden', 'hidden')
    link.querySelector('.spinner-border')?.removeAttribute('hidden')

    try {
      const response = await fetch(link.dataset.productUrl)
      if (response.ok) {
        const text = await response.text()
        const newDoc = new DOMParser().parseFromString(text, 'text/html')
        const modal = document.querySelector('product-quick-view-modal')
        if (modal && typeof modal.showModal === 'function') {
          modal.showModal(newDoc)
        }
      }
    } catch (err) {
      if (typeof window.zenaLog === 'function') {
        window.zenaLog('error', 'Failed to open video quick view', err)
      }
    } finally {
      link.disabled = false
      link.removeAttribute('aria-busy')
      link.querySelector('.icon-wrapper')?.removeAttribute('hidden')
      link.querySelector('.spinner-border')?.setAttribute('hidden', 'hidden')
    }
  }
}
customElements.define('shoppable-videos', ShoppableVideos)

class StickyATC extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback () {
    this.init()
  }

  init () {
    if (this._initialized) return
    this._initialized = true

    const stickyAtc = this
    const atcBlock = document.querySelector('.product-main .product-block-atc') || document.querySelector('.product-form') || document.querySelector('[name="add"]')
    if (!stickyAtc) return

    let lastScrollY = window.scrollY
    let ticking = false

    const updateSticky = () => {
      const currentScrollY = window.scrollY
      const atcRect = atcBlock ? atcBlock.getBoundingClientRect() : null
      const atcBottom = atcRect ? (atcRect.top + currentScrollY + atcRect.height) : 350
      const footer = document.querySelector('#footer-group') || document.querySelector('#footer') || document.querySelector('footer')
      const windowHeight = window.innerHeight
      const docHeight = document.documentElement.scrollHeight

      // Trigger threshold: past the main product CTA
      const isPastATC = currentScrollY > (atcBottom - 60)

      // Check if user is near the bottom of the page or in the footer area
      const isNearBottom = (currentScrollY + windowHeight >= docHeight - 80) || (footer && footer.getBoundingClientRect().top <= windowHeight - 40)

      // Direction detection (with 3px jitter tolerance)
      const scrollDiff = currentScrollY - lastScrollY
      const isScrollingDown = scrollDiff > 3
      const isScrollingUp = scrollDiff < -3

      if (!isPastATC) {
        // Above the product CTA -> completely hidden
        stickyAtc.classList.remove('show')
        stickyAtc.classList.remove('hide-slide-down')
        document.body.style.paddingBottom = '0'
      } else {
        // Below the product CTA
        if (isNearBottom) {
          if (isScrollingDown) {
            // Scrolling down in/near footer -> slide down and hide smoothly so user can see footer
            stickyAtc.classList.remove('show')
            stickyAtc.classList.add('hide-slide-down')
          } else if (isScrollingUp) {
            // Scrolling up slightly -> re-appear from bottom immediately!
            stickyAtc.classList.add('show')
            stickyAtc.classList.remove('hide-slide-down')
          }
        } else {
          // Normal middle of page -> stay shown
          stickyAtc.classList.add('show')
          stickyAtc.classList.remove('hide-slide-down')
          document.body.style.paddingBottom = stickyAtc.clientHeight + 'px'
        }
      }

      lastScrollY = currentScrollY
      ticking = false
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateSticky)
        ticking = true
      }
    }, { passive: true })

    this.listenVariantChange()
  }

  listenVariantChange () {
    window.addEventListener('kt.product.variant.change', (event) => {
      const selectedVariant = event.detail
      const select = this.querySelector('select[name="id"]')
      if (select && selectedVariant?.id) {
        select.value = selectedVariant.id
        select.dispatchEvent(new CustomEvent('change'))
      }
    })
  }
}
customElements.define('sticky-atc', StickyATC)

class BottomBar extends HTMLElement {
  constructor () {
    super()

    const stickyATC = document.querySelector('#sticky-atc')

    if (stickyATC) {
      this.closest('.bottom-bar-wrapper')?.remove()
    }
  }
}
customElements.define('bottom-bar', BottomBar)

class TimelineSlider extends HTMLElement {
  constructor () {
    super()

    this.thumbs = new window.Swiper(this.querySelector('.swiper-thumbs'), {
      rewind: true,
      breakpoints: {
        0: {
          slidesPerView: 3,
          spaceBetween: 16
        },
        600: {
          slidesPerView: Number(this.dataset.totalSlides),
          spaceBetween: 32
        },
      }
    })

    this.main = new window.Swiper(this.querySelector('.swiper-main'), {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      autoplay: this.autoplay,
      thumbs: {
        swiper: this.thumbs,
        autoScrollOffset: 0
      }
    })

    document.addEventListener('shopify:block:select', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {    
        this.main.slideTo(event.target.dataset.index)
      }
    })
  }

  autoplay = this.dataset.sliderAutoplay === '0'
    ? undefined
    : { delay: Number(this.dataset.sliderAutoplay) * 1000 }
}
customElements.define('timeline-slider', TimelineSlider)

class InstagramGallery extends HTMLElement {
  constructor () {
    super()

    this.gallery = new window.Swiper(this, {
      speed: Number(this.dataset.sliderSpeed),
      spaceBetween: 0,
      centeredSlides: true,
      autoplay: this.autoplay,
      loop: true,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next'
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      breakpoints: {
        0: {
          slidesPerView: 1.4
        },
        600: { 
          slidesPerView: 2
        },
        900: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        },
        1500: {
          slidesPerView: 5
        },
        1800: {
          slidesPerView: 6
        }
      }
    })

    this.querySelectorAll('a[data-quick-view]').forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        this.openQuickView(link)
      })
    })
  }

  autoplay = this.dataset.sliderAutoplay === '0'
    ? undefined
    : { delay: Number(this.dataset.sliderAutoplay) * 1000, pauseOnMouseEnter: true }

  async openQuickView (link) {
    if (!link || !link.dataset.productUrl) return

    link.disabled = true
    link.setAttribute('aria-busy', 'true')
    link.querySelector('.icon-wrapper')?.setAttribute('hidden', 'hidden')
    link.querySelector('.spinner-border')?.removeAttribute('hidden')

    try {
      const response = await fetch(link.dataset.productUrl)
      if (response.ok) {
        const text = await response.text()
        const newDoc = new DOMParser().parseFromString(text, 'text/html')
        const modal = document.querySelector('product-quick-view-modal')
        if (modal && typeof modal.showModal === 'function') {
          modal.showModal(newDoc)
        }
      }
    } catch (err) {
      if (typeof window.zenaLog === 'function') {
        window.zenaLog('error', 'Failed to open instagram gallery quick view', err)
      }
    } finally {
      link.disabled = false
      link.removeAttribute('aria-busy')
      link.querySelector('.icon-wrapper')?.removeAttribute('hidden')
      link.querySelector('.spinner-border')?.setAttribute('hidden', 'hidden')
    }
  }
}
customElements.define('instagram-gallery', InstagramGallery)